import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { IP } from "../../../config/IP";
import store from "../../../store/createStore";
import { loadCart, removeProduct } from "../../services/cart/actions";
import { createOrder } from "../../services/order/actions";
import { updateCart } from "../../services/total/actions";
import util from "../../services/util";
import CartProduct from "./CartProduct";
import "./style.css";

class FloatCart extends Component {
	static propTypes = {
		loadCart: PropTypes.func.isRequired,
		updateCart: PropTypes.func.isRequired,
		cartProducts: PropTypes.array.isRequired,
		newProduct: PropTypes.object,
		removeProduct: PropTypes.func,
		productToRemove: PropTypes.object,
	};
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.newProduct !== this.props.newProduct) {
			this.addProduct(nextProps.newProduct);
		}

		if (nextProps.productToRemove !== this.props.productToRemove) {
			this.removeProduct(nextProps.productToRemove);
		}
	}

	openFloatCart = () => {
		this.setState({ isOpen: true });
	};

	closeFloatCart = () => {
		this.setState({ isOpen: false });
	};

	addProduct = (product) => {
		const { cartProducts, updateCart } = this.props;
		let productAlreadyInCart = false;

		cartProducts.forEach((cp) => {
			if (!product.quantity) {
				product.quantity = 1;
			}
			if (
				cp.id === product.id &&
				cp.companyId === product.companyId &&
				cp.siteId === product.siteId
			) {
				cp.quantity = parseInt(cp.quantity) + parseInt(product.quantity);
				productAlreadyInCart = true;
			}
		});

		if (!productAlreadyInCart) {
			product.quantity = 1;
			cartProducts.push(product);
		}

		updateCart(cartProducts);
		this.openFloatCart();
	};

	removeProduct = (product) => {
		const { cartProducts, updateCart } = this.props;

		const index = cartProducts.findIndex((p) => p.id === product.id);
		if (index >= 0) {
			cartProducts.splice(index, 1);
			updateCart(cartProducts);
		}
	};

	proceedToCheckout = async () => {
		const {
			totalPrice,
			productQuantity,
			currencyFormat,
			currencyId,
		} = this.props.cartTotal;

		if (!productQuantity) {
			alert("Add some product in the bag!");
		} else {
			/*
			alert(
				`Checkout - Subtotal: ${currencyId} ${util.formatPrice(
					totalPrice,
					currencyId
				)}`
			);
			*/
			let items = this.props.cartProducts;

			let inputs = {
				url: IP.nodeServer + "api/createOrder",
				method: "POST",
				data: {
					totalCost: totalPrice,
					currencyFormat: currencyFormat,
					currencyId: currencyId,
					action: "new_Order",
					items: items,
					leftInstallments: this.props.cartProducts.map((y) => ({
						sku: y.sku,
						installments: y.installments,
					})),
				},
			};

			console.log("FloatCart inputs=", inputs);
			await store.dispatch(createOrder(inputs));
			//console.log("store.getState().order=", store.getState().order);

			/*	this.props.history.push({
				pathname: "/Shop/Order",
				state: { cartTotal: this.props.cartTotal },
      });
      */
		}
	};
	componentDidUpdate(nextProps) {
		if (this.props.order.isSaved) {
			/*
			this.props.history.push({
				pathname: `/Shop/Order/${this.props.order.order._id}`,
				state: { cartTotal: this.props.cartTotal },
			});
			*/
			window.location.href = `${IP.reactServer}Shop/Order/${this.props.order.order._id}`;
		}
	}

	render() {
		const { cartTotal, cartProducts, removeProduct } = this.props;

		const products = cartProducts.map((p) => {
			return (
				<CartProduct product={p} removeProduct={removeProduct} key={p.id} />
			);
		});

		let classes = ["float-cart"];

		if (!!this.state.isOpen) {
			classes.push("float-cart--open");
		}

		return (
			<div className={classes.join(" ")}>
				{/* If cart open, show close (x) button */}
				{this.state.isOpen && (
					<div
						onClick={() => this.closeFloatCart()}
						className="float-cart__close-btn"
					>
						X
					</div>
				)}

				{/* If cart is closed, show bag with quantity of product and open cart action */}
				{!this.state.isOpen && (
					<span
						onClick={() => this.openFloatCart()}
						className="bag bag--float-cart-closed"
					>
						<span className="bag__quantity">{cartTotal.productQuantity}</span>
					</span>
				)}

				<div className="float-cart__content">
					<div className="float-cart__header">
						<span className="bag">
							<span className="bag__quantity">{cartTotal.productQuantity}</span>
						</span>
						<span className="header-title">Bag</span>
					</div>

					<div className="float-cart__shelf-container">
						{products}
						{!products.length && (
							<p className="shelf-empty">
								Add some products in the bag <br />
								:)
							</p>
						)}
					</div>

					<div className="float-cart__footer">
						<div className="sub">SUBTOTAL</div>
						<div className="sub-price">
							<p className="sub-price__val">
								{`${cartTotal.currencyFormat} ${util.formatPrice(
									cartTotal.totalPrice,
									cartTotal.currencyId
								)}`}
							</p>
							<small className="sub-price__installment">
								{!!cartTotal.installments && (
									<span>
										{`OR UP TO ${cartTotal.installments} x ${
											cartTotal.currencyFormat
										} ${util.formatPrice(
											cartTotal.totalPrice / cartTotal.installments,
											cartTotal.currencyId
										)}`}
									</span>
								)}
							</small>
						</div>
						<div onClick={() => this.proceedToCheckout()} className="buy-btn">
							Checkout
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	cartProducts: state.cart.products,
	newProduct: state.cart.productToAdd,
	productToRemove: state.cart.productToRemove,
	cartTotal: state.total.data,
	order: state.order,
});

export default connect(mapStateToProps, {
	loadCart,
	updateCart,
	removeProduct,
	createOrder,
})(withRouter(FloatCart));
